
export { CredentialGuard } from "/home/runner/work/capsicum/capsicum/libs/socios-core/web/auth/index.ts"